import axios from "axios"
import * as Constants from '../../../constants/urls';
import React, { useEffect, useRef, useState } from "react"
import BarcodeForm from "../forms/BarcodeForm"
import LocationForm from "../forms/LocationForms"
import LocationLabel from "../Labels/LocationLable"
import { useCookies } from "react-cookie";
import LocationModal from "../Modal/LocationModal";
import ProductRow from "../product/ProductRow";
import NotFindModal from "../Modal/NotFindModal";
import SuccessModal from "../Modal/SuccessModal";
import AnbarGardaniForm from "../forms/AnbarGardaniForm";
import AnbargardaniLabel from "../Labels/AnbargardaniLabel";
import LostProductModal from "../Modal/LostProductModal";
import EndLocationModal from "../Modal/EndLocationModal";
import LastLogModal from "../Modal/LastLogModal";
import ShortcutsModal from "../Modal/ShortcutsModal";
import YesNoModal from "../../Modal/YesNoModal";
import SettingsLinearBlackImage from '../../../assets/images/settings_solid_black.png';
import AnbargardaniStepOneSetting from "../Setting/AnbargardaniStepOneSetting";
import OkModal from "../../Modal/OkModal";
import Loading from "../../Loading/Loading";

const Step1 = (props) => {
    const [location, setLocation] = useState("")
    const [locationInput, setLocationInput] = useState("")
    const [barcode, setBarcode] = useState("")
    const [barcodeInput, setBarcodeInput] = useState("")
    const [anbargardaniList, setanbargardaniList] = useState(undefined)
    const [lostProducts, setLostProducts] = useState(undefined)
    const [anbargardani, setanbargardani] = useState(true)
    const [anbargardaniTitle, setanbargardaniTitle] = useState("1404")
    const [anbargardaniId, setanbargardaniId] = useState(4)
    const [product, setProduct] = useState(undefined)
    const [queueProduct, setqueueProduct] = useState(undefined)
    const [lastLogModal, setLastLogModal] = useState(false)
    const [locationModal, setLocationModal] = useState(false)
    const [notFindModal, setNotFindModal] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [endLocationModal, setEndLocationModal] = useState(false)
    const [lostModal, setLostModal] = useState(false)
    const [stock, setStock] = useState([])
    const [shortcutModal, setShortcutModal] = useState(false)
    const [closeWithLocation, setCloseWithLocation] = useState(false)
    const [closeWithAnbar, setCloseWithAnbar] = useState(false)
    const [closeWithButton, setCloseWithButton] = useState(false)
    const [shortcutProps, setShortcutProps] = useState(undefined)
    const [settingMenu, setSettingMenu] = useState(false)
    const [validate, setValidate] = useState(false)
    const [loading, setLoading] = useState(false);

    const [cookies, setCookie, removeCookie] = useCookies();
    const input = useRef(null);

    const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
const a2e = s => s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))

    function getAnbargardani() {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/getAnbargardaniList";
        axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setanbargardaniList(r.data);
            setLoading(false);

        }).catch((e) => {
   if(e.response.status==403)
            {
                window.location="403";
            }
            setLoading(false);

        });
    }

    function getProduct(barcode) {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/getPackByBarcodeAndLocation";
        axios.post(url, {
            barcode: barcode,
            location: location,
            anbargardaniId:anbargardaniId
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLoading(false);

            let productArray = product == undefined ? [] : product;
            const found = productArray.find(obj => {
                return obj.barCode === barcode;
            });

            if (found == null) {

                    if (r.data.alertText == "" || r.data.alertText == null) {
                        if (r.data.locationIsTrue) {

                        let productArray = product == undefined ? [] : product;
                        const found = productArray.find(obj => {
                            return obj.barCode === barcode;
                        });

                        productArray.push(r.data);
                        setProduct(productArray);
                        let stockObject = stock;
                        let newStockObject = { packId: r.data.id, productId: r.data.product_id, oldStock: r.data.stock, count: r.data.count, stock: "" }
                        stockObject.push(newStockObject);
                        setStock(stockObject);
                        setBarcodeInput("");
                    }
                    else {
                        setLocationModal(true);
                        setqueueProduct(r.data)
                    }
                }
                else {
                    
                    setqueueProduct(r.data)
                    setLastLogModal(true);
                }
            }
        }).catch((e) => {
            console.error("statusError", e.status);
            setLoading(false);

            if (e.response.status == 404) {
                setNotFindModal(true);
            }
        });
    }

    const addQeueProductToProducts = () => {
       
        let productArray = product == undefined ? [] : product;
        const found = productArray.find(obj => {
            return obj.barCode === barcode;
        });
        if (found == null) {
            if(queueProduct.location!=location)
            {
                ChangeProductLocation();
            }
            else
            {
            productArray.push(queueProduct);
            setProduct(productArray);
            let stockObject = stock;
            let newStockObject = { packId: queueProduct.id, productId: queueProduct.product_id, oldStock: queueProduct.stock, count: queueProduct.count, stock: "" }

            stockObject.push(newStockObject);
            setStock(stockObject);
            setBarcodeInput("");
            }
        }
        setLastLogModal(false);
        setqueueProduct(undefined);
    }

    const emptyProductsQueue = () => {
        setqueueProduct(undefined);
        setLastLogModal(false);

    }
    const ChangeProductLocation = (e) => {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/changePackLocation";
        axios.post(url, {
            barcode: barcode,
            location: location,
            packId: queueProduct.id,
            productId: queueProduct.product.id,
            oldLocation: queueProduct.location,
            newLocation: location
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLoading(false);

            setSuccessModal(true);
            setLocationModal(false);
            let productArray = product == undefined ? [] : product;
            const found = productArray.find(obj => {
                return obj.barCode === barcode;
            });
            if (found == null) {
                productArray.push(queueProduct);
                setProduct(productArray);
                let stockObject = stock;
                let newStockObject = { packId: queueProduct.id, productId: queueProduct.product_id, oldStock: queueProduct.stock, count: queueProduct.count, stock: "" }
                stockObject.push(newStockObject);
                setStock(stockObject);
                setBarcodeInput("");
            }

        }).catch((e) => {
            setLoading(false);

            console.error(e);
        });
    }
    const findLostProducts = () => {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/findLostProducts";
        axios.post(url, {
            anbargardaniId: anbargardaniId,
            location: location,
            packs:stock,
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLoading(false);

            setLostProducts(r.data);
            if (r.data != "")

                setLostModal(true);
            else
                setEndLocationModal(true);

        }).catch((e) => {
            console.error(e);
            setLoading(false);

        });
    }
    const closeThisLocation = () => {
        setLoading(true);
        setEndLocationModal(false)

        const url = Constants.apiUrl + "/api/ag/closeLocation";
        axios.post(url, {
            anbargardaniId: anbargardaniId,
            location: location,
            packs: stock,
            step: 0
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setSuccessModal(true);
            setStock([]);
            setProduct(undefined);
            setLocationInput("");
            setBarcode("");
            setBarcodeInput("");
            setLocation("");
            setEndLocationModal(false)
            setLoading(false);

        }).catch((e) => {
            console.error(e);
            setLoading(false);

        });
    }
    const applyStock = (e) => {
        setLoading(true);

        const url = Constants.apiUrl + "/api/ag/submitPackStock";
        axios.post(url, {
            barcode: barcode,
            location: location,
            packId: product.id,
            productId: product.product.id,
            count: product.count,
            oldStock: product.stock,
            newStock: stock,
            anbargardaniId: anbargardaniId
        }, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLoading(false);

            setSuccessModal(true);
            setProduct(undefined);
            setStock([]);


        }).catch((e) => {
            setLoading(false);

            console.error(e);
        });
    }

    const changeLocation = (e) => {
        setLocationInput(p2e(a2e(e.target.value)));
    }
    const selectLocation = () => {
        setLocation(p2e(a2e(locationInput)));
        setProduct(undefined);
        setStock([]);

    }
    const cleanLocation = () => {
        setLocation("");
        setProduct(undefined);
        setCloseWithLocation(false);

    }
    const changeBarcodeInput = (e) => {
    
        setBarcodeInput(p2e(a2e(e.target.value)));
    }
    const selectBarcode = (e) => {
            setBarcode(p2e(a2e(barcodeInput)));
        getProduct(p2e(a2e(barcodeInput)));

    }
    const closeLocationModal = () => {
        setLocationModal(false);
        setqueueProduct(undefined); 

    }
    const closeNotFindModal = () => {
        setNotFindModal(false);
    }
    const closeSuccessModal = () => {
        setSuccessModal(false);
    }
    const anbargardaniHandle = (e) => {
        setanbargardaniId(e.target.value);
        setanbargardaniTitle(e.target.selectedOptions[0].innerText);
    }
    const anbargardaniSelectHandle = (e) => {
        if (anbargardaniId != 0)
            setanbargardani(true);
    }
    const cleanAnbargardani = (e) => {
        setanbargardani(false);
        setCloseWithAnbar(false)
        setanbargardaniId("");
        setanbargardaniTitle("");
        cleanLocation();
        setStock([]);

    }
    const exit = () => {
        window.location.href = "/admin/anbarGardani"
    }
    const changeStockHandler = (e) => {
        // if(e.target.value>=0 || e.target.value<=9)
        let newStock = p2e(a2e(e.target.value));
        let packId = e.target.attributes.packId.value;

        if (stock != []) {
            const newState = stock.map(obj => {
                if (obj.packId == packId) {
                    return { ...obj, stock: newStock };
                }
                return obj;
            });
            setStock(newState);
        }
    }
    const checkLocationEnter=(e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            selectLocation();
          }
    }
    const stockValidation=()=>{
        let valid=false;
        stock.map(obj => {
            if (obj.stock == "" || obj.stock == null) { 
                valid= true;
            }
        }); 
        return valid
    }
    const submitThisLocation = () => {
     
        if(stockValidation()==true)
        setValidate(true);
         else
        findLostProducts();
    }
    const closeLostModal = () => {
        setLostModal(false);
    }
    const closeEndLocationModal = () => {
        setEndLocationModal(false);
    }
    const sumbitEndLocation = () => {
        setLostModal(false);
        closeThisLocation();
    }
    const openShortcutModal = (e) => {

        let productId = e.target.attributes.productId.value;
        let productUrl = e.target.attributes.productUrl.value;
        setShortcutProps({ id: productId, url: productUrl });
        setShortcutModal(true);
    }
const checkBarcodeEnter =(e)=>{
     if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        selectBarcode();
      }
}

 
  useEffect(()=>{
    if(input.current)
    input.current.focus();
  },[location,
    product,
    queueProduct,
    lastLogModal,
    locationModal,
    notFindModal,
    successModal,
    validate,
    endLocationModal])

useEffect(() => {

            window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        })

        window.onbeforeunload = () => {
            return false;
        };
    })
    
    useEffect(() => {
        getAnbargardani();
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        })
   
        window.onbeforeunload = ()=>{
            return false;
        };
    }, [])
    const [state, setState] = React.useState({ right: false });


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };
    return (
        <div className="anbarBody" style={{position:"absolute",top:"0",right:"0",zIndex:"1111111"}}>
            <React.Fragment>
            {loading ? <div style={{position:"absolute",top:0,zIndex:10}}><Loading /></div> : ""}

                {endLocationModal ? <EndLocationModal apply={sumbitEndLocation} close={closeEndLocationModal} /> : ""}
                {successModal ? <SuccessModal apply={closeSuccessModal} /> : ""}
                {notFindModal ? <NotFindModal apply={closeNotFindModal} /> : ""}
                {validate ? <OkModal headerTitle={"اخطار"} btnTitle={"تایید"} ok={()=>{setValidate(false)}} message={" .... پر کردن همه ی فیلد ها الزامی است"}/> : ""}

                {closeWithLocation ? <YesNoModal massage={"آیا از تغییر لوکیشن اطمینان دارید ؟ تمام داده ها پاک میشود"} yes={cleanLocation} no={() => { setCloseWithLocation(false) }} /> : ""}
                {closeWithAnbar ? <YesNoModal massage={"آیا از تغییر انبارگردانی اطمینان دارید ؟ تمام داده ها پاک میشود"} yes={cleanAnbargardani} no={() => { setCloseWithAnbar(false) }} /> : ""}
                {closeWithButton ? <YesNoModal massage={"آیا از خروج اطمینان دارید ؟ تمام داده ها پاک میشود"} yes={exit} no={() => { setCloseWithButton(false) }} /> : ""}

                {shortcutModal ? <ShortcutsModal props={shortcutProps} close={() => { setShortcutModal(false) }} /> : ""}
                {(lostModal && lostProducts != undefined) ? <LostProductModal apply={sumbitEndLocation} close={closeLostModal} lostProducts={lostProducts} /> : ""}
                {queueProduct != undefined && locationModal ? <LocationModal oldLocation={queueProduct.location} stock={queueProduct.stock} close={closeLocationModal} apply={ChangeProductLocation} /> : ""}
                {queueProduct != undefined && lastLogModal ? <LastLogModal text={queueProduct.alertText} close={emptyProductsQueue} apply={addQeueProductToProducts} /> : ""}

                <div className="" >

                    <div className="container-fluid  bg-primary py-3" style={{ position: "fixed", zIndex: 1, top: "0" }}>
                        <div className="container text-right" >
                            <div style={{ position: "relative" }}>
                                <img src={SettingsLinearBlackImage} style={{ cursor: "pointer", width: '30px', height: "30px" }} onClick={() => { setSettingMenu(!settingMenu) }} />
                                {settingMenu && <AnbargardaniStepOneSetting anbargardani={() => { setCloseWithAnbar(true); setSettingMenu(false) }} location={() => { setCloseWithLocation(true); setSettingMenu(false) }} exit={() => {exit() }} />}
                            </div>
                        </div>
                        {!anbargardani ? <AnbarGardaniForm anbargardani={anbargardaniList} selectAnbargardani={anbargardaniHandle} applyAnbargardani={anbargardaniSelectHandle} />
                            :
                            <>
                                {location != "" ?
                                    <>
                                        <BarcodeForm barcodeInput={barcodeInput} refinput={input} changeBarcodeInput={changeBarcodeInput} checkBarcodeEnter={checkBarcodeEnter} selectBarcode={selectBarcode} />
                                    </>
                                    :
                                    <LocationForm changeLocation={changeLocation} locationInput={locationInput} checkLocationEnter={checkLocationEnter} selectLocation={selectLocation} />
                                }
                            </>
                        }
                    </div>
                    <div className="container">
                        <div className="text-center row" style={{ marginTop: "200px" }}>
                            {anbargardani && <AnbargardaniLabel anbargardani={anbargardaniTitle} />}
                            {location && <LocationLabel location={location} />}
                        </div>
                    </div>

                    {product != undefined && product != null ?
                        <>
                            <div >
                                {
                                    product.map((item, index) => {
                                        return (
                                            <div className="container my-4" style={{ borderRadius: "5px", border: "1px solid rgb(219, 219, 219)", minHeight: "100px" }}>

                                                <ProductRow openShortcut={openShortcutModal} image={item.product.prodID} name={item.product.prodName_fa} label={item.label} count={item.count} prodStock={stock} packId={item.id} productId={item.product_id} productUrl={item.product.url} changeStock={changeStockHandler} submit={applyStock} />
                                            </div>
                                        )
                                    })
                                }
                            </div>


                        </>
                        : ""}

                    {location != "" ?

                        <div className="mt-5">
                            <button className="btn btn-block btn-danger" disabled={loading} onClick={submitThisLocation}>
                                ثبت این لوکیشن
                            </button>
                        </div>
                        : ""}
                </div>

            </React.Fragment>
        </div>
    )
}
export default Step1;

